module.exports = __webpack_public_path__ + "img/no-img.8865f01b.jpg";